import script from "./ChatResendModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatResendModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChatResendModal.vue?vue&type=style&index=0&id=3cd73cd9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd73cd9"]])

export default __exports__